import { render, staticRenderFns } from "./ModalOrderView.vue?vue&type=template&id=05db3371&scoped=true&"
import script from "./ModalOrderView.vue?vue&type=script&lang=js&"
export * from "./ModalOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05db3371",
  null
  
)

export default component.exports